import { Box, Button, TextField, Tooltip, Typography } from "@mui/material"
import { Search } from "lucide-react"
import styles from './SearchByLaximoVinContainer.module.scss'

interface SearchInputProps {
    searchVIN: string;
    setSearchVIN: (value: string) => void;
    handleSearch: () => void;
    carNumber: string;
    carNumberRegion: string;
}

export const SearchInput = ({
    searchVIN,
    setSearchVIN,
    handleSearch,
    carNumber,
    carNumberRegion
}: SearchInputProps) => {
    /** Обработка ввода */
    const handleInputChange = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    }

    return carNumber && carNumberRegion
        ? <Box style={{ marginBottom: 15 }}>
            <Typography variant="h6" style={{ padding: 12 }}>Поиск по госномеру {carNumber} / {carNumberRegion} RUS</Typography>
        </Box>
        : <Box style={{ marginBottom: 15 }}>
            <Box style={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                <Box style={{ flex: 1 }}>
                    <TextField
                        margin="normal"
                        fullWidth
                        placeholder="Поиск по VIN или номеру кузова"
                        label="Поиск по VIN или номеру кузова"
                        value={searchVIN}
                        variant="outlined"
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => setSearchVIN(event.target.value)}
                        onKeyDown={handleInputChange}
                        style={{ marginLeft: 8, width: '98%' }}
                    />
                </Box>
                <Box>
                    <Button disabled={!searchVIN} className={styles.actionButton} color="secondary" variant="outlined" onClick={handleSearch}>
                        <Search />
                    </Button>
                </Box>
            </Box>
            <Box style={{ paddingLeft: 2 }}>
                <Typography style={{ paddingLeft: 16 }} variant="body2">
                    Введите VIN или номер кузова, например,
                    <Tooltip placement="top-end" title={<img src="/img/vin.png" />}>
                        <span style={{ cursor: 'pointer', textDecoration: 'underline dotted', marginLeft: 16 }}>JTJHK31U802038156</span>
                    </Tooltip>
                </Typography>
            </Box>
        </Box>
}
